export default __webpack_public_path__ + "static/automobile-parallax-34ebc874632ee23ad4721a2d9808abbd.gif";